import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { useSeo } from "../lib/seo";
import { useAuth } from "../context/AuthContext";
import { CallCard } from "../components/dashboard/CastingCalls";

const Action = ({ c, user }) => (c.open ? (user === null ? null : (
  <Link to={user ? "/dashboard?tab=casting" : "/register"} className="shrink-0 bg-primary text-primary-foreground px-5 py-3 font-bold uppercase text-xs tracking-wider hover:bg-[hsl(43,100%,60%)] transition-colors inline-flex items-center gap-2" data-testid="call-detail-action">
    {user ? "I'm available" : "Join to apply"} <ArrowRight size={14} />
  </Link>
)) : <span className="shrink-0 border border-white/15 px-5 py-3 text-xs font-bold uppercase tracking-wider text-white/50" data-testid="call-detail-closed">This call has closed</span>);

export default function CastingCallDetail() {
  const { id } = useParams();
  const { user } = useAuth();
  const [c, setC] = useState(undefined);
  useEffect(() => {
    api.get(`/public/casting-calls/${id}`).then((r) => setC(r.data)).catch(() => setC(null));
  }, [id]);
  useSeo(c ? `Extras wanted: ${c.production_title || `${c.extras_needed} extras`} in ${c.location} | extras.tv` : "Casting call | extras.tv",
    c ? `${c.extras_needed} extras needed in ${c.location} · ${c.shoot_dates}.` : "Casting calls for TV and film extras on extras.tv.");

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-10 py-16" data-testid="call-detail-page">
      <Link to="/casting-calls" className="label-xs inline-flex items-center gap-2 hover:text-primary" data-testid="call-detail-back"><ArrowLeft size={12} /> All casting calls</Link>
      <div className="mt-8">
        {c === undefined && <p className="label-xs">Loading…</p>}
        {c === null && (
          <div className="border border-dashed border-white/15 p-16 text-center" data-testid="call-detail-missing">
            <p className="font-display text-2xl">This casting call isn't available</p>
            <Link to="/casting-calls" className="text-primary text-sm mt-4 inline-block">See current casting calls</Link>
          </div>
        )}
        {c && <CallCard c={c} full action={<Action c={c} user={user} />} />}
      </div>
    </div>
  );
}
